import { config } from 'config';
import { restAPIV2 } from './rest_api_v2';
import { toVfId, toUuid } from 'commons/util/parse.js';

const routes = {
    page: (page_uuid) => `/pages/${toVfId(page_uuid)}`,
};

const getDefaultRestAPIV2 = (site_uuid) => restAPIV2.register(config.api_v2_url, site_uuid);

export const requestPage = (page_uuid, site_uuid) => getDefaultRestAPIV2(toVfId(site_uuid))
    .get(routes.page(page_uuid))
    .then((page) => Object.assign({}, page, { uuid: toUuid(page.id) }));
